import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import {
	BulkAddCounterpartyJobStatus,
	BulkAddCounterpartyJobStatusRes,
} from '@dealstack/shared/lib/generated';
import { useBulkJobStatus } from './useBulkJobStatus';

const TERMINAL_STATUSES: readonly BulkAddCounterpartyJobStatus[] = [
	BulkAddCounterpartyJobStatus.COMPLETED,
	BulkAddCounterpartyJobStatus.FAILED,
];

const buildStatusEndpoint = (dealId: string, programmeId: string, jobId: string): string =>
	`${formatUnicorn(API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_ADD_COUNTERPARTY_POST, { dealId, programmeId })}-status/${jobId}`;

export const useBulkAddCounterpartyStatus = ({
	dealId,
	programmeId,
	jobId,
	onTerminal,
}: {
	dealId: string;
	programmeId: string;
	jobId: string | null;
	onTerminal?: (state: BulkAddCounterpartyJobStatusRes) => void;
}) =>
	useBulkJobStatus<BulkAddCounterpartyJobStatusRes>({
		dealId,
		programmeId,
		jobId,
		queryKeyPrefix: 'bulk-add-counterparty-status',
		buildStatusEndpoint,
		terminalStatuses: TERMINAL_STATUSES,
		onTerminal,
	});
